import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const cards = [
  { key: 'review', icon: 'ri-star-line', href: '/pt/articles/cssbuy-legit-safety' },
  { key: 'shipping', icon: 'ri-truck-line', href: '/pt/articles/cssbuy-shipping-cost' },
  { key: 'coupon', icon: 'ri-coupon-line', href: '/pt/articles/cssbuy-coupon-guide' },
  { key: 'warehouse', icon: 'ri-building-4-line', href: '/pt/articles/cssbuy-warehouse-guide' },
  { key: 'legit', icon: 'ri-shield-check-line', href: '/pt/articles/cssbuy-legit-safety' },
];

export default function CommercialCards() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-warm-900 mb-3">
            {t('commercialCards.h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((card) => (
            <Link
              key={card.key}
              to={card.href}
              className="group block bg-warm-50 rounded-xl border border-warm-200 p-5 md:p-6 hover:border-brand-200 transition-all duration-300 hover:shadow-sm"
            >
              <div className="w-10 h-10 rounded-lg bg-white border border-warm-200 flex items-center justify-center text-brand-600 mb-4 group-hover:border-brand-300 transition-colors">
                <i className={`${card.icon} text-lg`} />
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-warm-900 mb-2">
                {t(`commercialCards.${card.key}`)}
              </h3>
              <p className="text-xs md:text-sm text-warm-500 leading-relaxed mb-4">
                {t(`commercialCards.${card.key}Desc`)}
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-brand-600 group-hover:text-brand-700 transition-colors">
                {t('commercialCards.cta')}
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}